/**
 * @file 日志发送统计工具
 * @author ss
 */

import config from './config';
import env from './env';
import { formatTime } from '../index';
import Request from '../Request';

function Image(id) {
  const imageID = `#${id || 'log_image_id'}`;
  let image = document.getElementById(imageID);
  if (image) return image;

  image = document.createElement('img');
  image.setAttribute('id', imageID);
  image.setAttribute('style', 'width: 1px; height: 1px;visibility: hidden; position: absolute; left: -99999px;bottom: 0;');
  document.body.appendChild(image);

  setTimeout(() => {
    document.body.removeChild(image);
  }, 200);

  return image;
}
/* eslint-disable */
function stringify(json) {
  let detail = '{';
  let i = 0;
  for (const x in json) {
    if (json[x]) {
      const gap = i > 0 ? ',' : '';
      detail += `${gap}"${x}":"${json[x]}"`;
      i++;
    }
  }
  detail += '}';
  return detail;
}
/* eslint-disable */

const logCommonInfo = {
  project_id: 'fe_customer_jack_h5',
  pid: `${env.getPhoneSys() === 'ios' ? '6' : '8'}0142`,
};

function _Log(key, detail, others) {
  const image = Image(new Date().getTime());
  const headersInfo = Request.getHeader() || {};

  let params = {
    pid: logCommonInfo.pid,
    entry_key: key,
    entry_detail: detail,
    common: logCommonInfo,
    client_time: formatTime(),
    headers: JSON.stringify(headersInfo),
  };

  if (others) {
    params = {
      ...params,
      ...others,
    };
  }
  params = JSON.stringify(params);

  let uri = `${config.uri}?data=${params}`;
  console.log(uri);
  image.setAttribute('src', encodeURI(uri));
}

// 嵌套一层函数，传入porject_id
function Log(project_id) {
  logCommonInfo.project_id = project_id;
  return _Log;
}
export default Log;



// WEBPACK FOOTER //
// ./src/utils/Log/index.js